module.exports = __webpack_public_path__ + "static/media/pasticceria_5.6fbeb3fa.jpg";